export const ADD_NOTICE_TYPE = "ADD_NOTICE_TYPE";
export const GET_NOTICE_TYPE_LIST = "GET_NOTICE_TYPE_LIST";
export const NOTICE_TYPE_LIST_RESPONCE = "NOTICE_TYPE_LIST_RESPONCE";
export const EDIT_NOTICE_TYPE = "EDIT_NOTICE_TYPE";
export const EDIT_NOTICE_TYPE_STATUS = "EDIT_NOTICE_TYPE_STATUS";
export const DELETE_NOTICE_TYPE = "DELETE_NOTICE_TYPE";




// redux state update 
export const EDIT_REDUX_STATE = "EDIT_REDUX_STATE";
export const DELETE_REDUX_STATE = "DELETE_REDUX_STATE";
export const EDIT_STATUS_REDUX_STATE = "EDIT_STATUS_REDUX_STATE";
export const EDIT_SIGN_STATUS_REDUX_STATE = "EDIT_SIGN_STATUS_REDUX_STATE";